import {
  PersistedFormGroup,
  PersistedFormArray,
  PersistedArray,
} from './persisted-form-group';
import type {
  PersistedFormGroupOptions,
  PersistedFormArrayOptions,
  PersistedArrayOptions,
} from './persisted-form-group';
import type { SchemaFormControl } from '@apexdesigner/schema-forms';
import { NotAvailable } from './not-available';
export { NotAvailable };
import { notAvailableSchema } from '@schemas/business-objects/not-available';
import { AlternateStudentFormGroup } from './alternate-student-form-group';
import { SelectedStudentFormGroup } from './selected-student-form-group';
import { TermFormGroup } from './term-form-group';
import { TermTutorFormGroup } from './term-tutor-form-group';

export class NotAvailableFormGroup extends PersistedFormGroup {
  declare controls: {
    id: SchemaFormControl;
    name: SchemaFormControl;
    startDate: SchemaFormControl;
    startTime: SchemaFormControl;
    endDate: SchemaFormControl;
    endTime: SchemaFormControl;
    termId: SchemaFormControl;
    term: TermFormGroup;
    termTutorId: SchemaFormControl;
    termTutor: TermTutorFormGroup;
    selectedStudentId: SchemaFormControl;
    selectedStudent: SelectedStudentFormGroup;
    alternateStudentId: SchemaFormControl;
    alternateStudent: AlternateStudentFormGroup;
  };

  declare value: Partial<NotAvailable>;

  constructor(
    data?: Record<string, any> | null,
    options?: PersistedFormGroupOptions,
  ) {
    super(notAvailableSchema, NotAvailable, data, options);
  }

  get object(): NotAvailable {
    return new NotAvailable(this.getRawValue());
  }

  protected override createControl(name: string) {
    switch (name) {
      case 'term':
        return new TermFormGroup();
      case 'termTutor':
        return new TermTutorFormGroup();
      case 'selectedStudent':
        return new SelectedStudentFormGroup();
      case 'alternateStudent':
        return new AlternateStudentFormGroup();
      default:
        return undefined;
    }
  }

  static async find(filter?: any): Promise<NotAvailable[]> {
    return NotAvailable.find(filter);
  }

  static async findOne(filter?: any): Promise<NotAvailable | null> {
    return NotAvailable.findOne(filter);
  }

  static async findById(id: number, filter?: any): Promise<NotAvailable> {
    return NotAvailable.findById(id, filter);
  }

  static async create(data: Partial<NotAvailable>): Promise<NotAvailable> {
    return NotAvailable.create(data as any);
  }

  static async updateById(
    id: number,
    updates: Partial<NotAvailable>,
  ): Promise<NotAvailable> {
    return NotAvailable.updateById(id, updates as any);
  }

  static async deleteById(id: number): Promise<boolean> {
    return NotAvailable.deleteById(id);
  }
}

export class NotAvailableFormArray extends PersistedFormArray {
  readonly entityName = 'NotAvailable' as const;

  constructor(options?: PersistedFormArrayOptions) {
    super(notAvailableSchema, NotAvailable, options);
  }

  protected override createItemGroup() {
    return new NotAvailableFormGroup();
  }

  get array(): NotAvailable[] {
    return this.controls.map((group: NotAvailableFormGroup) => group.object);
  }
}

export class NotAvailablePersistedArray extends PersistedArray<NotAvailable> {
  readonly entityName = 'NotAvailable' as const;

  constructor(options?: PersistedArrayOptions) {
    super(NotAvailable, options);
  }
}
